<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="">
      <p class="text-2xl flex justify-center text-root-2 font-bold -mt-10">
        Beneficiary
      </p>
      <div class="mt-8">
        <div v-for="(beneficiary, index) in beneficiaryList" :key="index">
          <div
            @click="fillBeneficiaryDetails(beneficiary)"
            class="border cursor-pointer rounded-lg w-full bg-gray-60 flex items-center p-4 mb-3"
          >
            <div
              v-if="
                beneficiary.transferDestination !==
                $transactionType.ASSET_TRANSFER
              "
              class="mr-4"
            >
              <el-avatar :size="60" class="bg-black-2 text-xl">{{
                beneficiary.name.charAt(0).toUpperCase()
              }}</el-avatar>
            </div>
            <div v-else class="mr-5">
              <el-avatar :size="60" class="bg-black-2 text-xl">{{
                beneficiary.details.walletDetails.walletAddress
                  .charAt(0)
                  .toUpperCase()
              }}</el-avatar>
            </div>
            <div
              v-if="
                beneficiary.transferDestination !==
                $transactionType.ASSET_TRANSFER
              "
              class="pr-12"
            >
              <p class="text-lg text-root-2 font-bold">
                {{ beneficiary.name }}
              </p>
              <p class="text-13px font-normal">
                Bank: {{ beneficiary.details.bankDetails.bankName }}
              </p>
              <p class="text-13px font-normal">
                Account number:
                {{ beneficiary.details.bankDetails.accountNumber }}
              </p>
              <p class="text-13px font-normal">
                Destination Country:
                {{ beneficiary.details.bankDetails.country }}
              </p>
            </div>
            <div v-else>
              <p class="text-13px font-normal">
                Wallet Address:
                {{ beneficiary.details.walletDetails.walletAddress }}
              </p>
              <p class="text-13px font-normal">
                Asset Type:
                {{ beneficiary.details.walletDetails.assetType }}
              </p>
              <p class="text-13px font-normal">
                Network:
                {{
                  parseNetworkName(beneficiary.details.walletDetails.network)
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import activeCurrency from '@/mixins/localDeposit.js'
import country from '@/mixins/getCountryDetails.js'
import { ParseNetworkName } from '@/utils/helpers.js'

export default {
  name: 'BeneficiaryDialog',
  mixins: [activeCurrency, country],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    beneficiaryList () {
      return this.$store.state.terminal.beneficiaries.filter(
        (beneficiary) =>
          beneficiary.destinationCurrency === this.secondaryCurrency
      )
    }
  },
  methods: {
    fillBeneficiaryDetails (beneficiary) {
      let details = {}
      if (
        beneficiary.transferDestination !== this.$transactionType.ASSET_TRANSFER
      ) {
        details = {
          accountNo: beneficiary.details.bankDetails.accountNumber,
          accountName: beneficiary.details.bankDetails.accountName,
          routingNo: beneficiary.details.bankDetails.routingNumber,
          bankName: beneficiary.details.bankDetails.bankName,
          bankCountry: beneficiary.details.bankDetails.country,
          bankBranch: beneficiary.details.bankDetails.bankBranch,
          bankCity: beneficiary.details.bankDetails.city,
          bankPostalCode: beneficiary.details.bankDetails.postalCode,
          bankCode: beneficiary.details.bankDetails.bankCode,
          bankAddress: beneficiary.details.bankDetails.bankAddress,
          recipientName: beneficiary.details.personalDetails?.name || '',
          recipientAddress: beneficiary.details.personalDetails?.address || '',
          recipientCountry: beneficiary.details.personalDetails?.country || '',
          swiftCode: beneficiary.details.bankDetails.swiftCode,
          intermediaryBankReference:
            beneficiary.details.intermediaryBank?.reference || '',
          intermediaryBankAddress:
            beneficiary.details.intermediaryBank?.bankAddress || '',
          intermediaryBankName:
            beneficiary.details.intermediaryBank?.bankName || '',
          intermediaryBankSwiftCode:
            beneficiary.details.intermediaryBank?.swiftCode || '',
          recipientCity: beneficiary.details.personalDetails?.city || '',
          recipientPostalCode:
            beneficiary.details.personalDetails?.postalCode || ''
        }
      } else {
        details = {
          walletAddress: beneficiary.details.walletDetails.walletAddress || '',
          asset: beneficiary.details.walletDetails?.assetType || '',
          network: beneficiary.details.walletDetails?.network || ''
        }
      }
      this.$store.dispatch('terminal/usedBeneficiary', true)
      this.$store.dispatch('terminal/beneficiaryID', beneficiary.id)
      this.$store.dispatch('terminal/setRecipientInformation', details)
      this.$emit('toReview')
      this.$emit('closeDialog')
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    parseNetworkName (networkType) {
      return ParseNetworkName(networkType)
    }
  }
}
</script>
